<template>
    <views class="aritcle-item" @click="onClick">
        <views class="aritcle-item-content">
            <views
                :class="{'only-title': onlyTitle}"
                class="aritcle-item-content-title">
                {{ item.name }}
            </views>
            <views
                v-if="!onlyTitle"
                class="aritcle-item-content-des">
                {{ item.introduce }}
            </views>
            <views class="aritcle-item-content-time">
                <images :src="timeIcon"></images>
                {{ item.created_at }}
            </views>
        </views>
        <views class="aritcle-item-img">
            <images :src="item.image_url"></images>
        </views>
    </views>
</template>

<script>
export default {
    props: {
        onlyTitle: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            timeIcon: require('@/assets/images/time.png')
        }
    },
    methods: {
        onClick() {
            this.$emit('click', this.item)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
.aritcle-item-img img{
    object-fit: cover;
    height: 100%;
    width: 100%;
}
</style>
